<!-- 注册页面 -->
<template>
  <div class="login_wrap">
    <div class="login_box">
      <!-- logo -->
      <div class="login_top">
        <span>个人用户注册</span>
        <!-- <img src="../../assets/imgs/login_logo.png" alt="" /> -->
      </div>

      <!-- 注册表单 -->
      <div class="login_bottom">
        <el-form
          :model="res_form"
          status-icon
          :rules="res_rules"
          ref="resForm"
          class="demo-ruleForm form"
          key="res_form"
        >
          <el-form-item prop="username" class="m_top_20">
            <el-input
              v-model="res_form.username"
              autocomplete="off"
              placeholder="请输入用户名"
            >
              <i slot="prefix" class="el-icon-user-solid el_icon"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" class="m_top_20">
            <el-input
              type="password"
              v-model="res_form.password"
              autocomplete="off"
              placeholder="请输入密码"
            >
              <i slot="prefix" class="el-icon-lock el_icon"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="checkPass" class="m_top_20">
            <el-input
              type="password"
              v-model="res_form.checkPass"
              autocomplete="off"
              placeholder="请再次输入密码"
            >
              <i slot="prefix" class="el-icon-lock el_icon"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="email" class="m_top_20">
            <el-input
              v-model="res_form.email"
              autocomplete="off"
              placeholder="请输入邮箱"
            >
              <i slot="prefix" class="el-icon-message"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="code" class="m_top_20">
            <el-input
              style="width: 73.5%"
              v-model="res_form.code"
              autocomplete="off"
              placeholder="请输入验证码"
            >
              <i slot="prefix" class="el-icon-document-checked"></i>
            </el-input>
            <el-button @click="codes" v-if="!btnBool" style="width: 25.5%">{{
              yzmtext
            }}</el-button>
            <el-button v-if="btnBool" style="width: 25.5%" disabled>{{
              yzmtext
            }}</el-button>
          </el-form-item>

          <!-- <el-form-item class="btns" style="">
             
          </el-form-item> -->
        </el-form>
        <div style="width: 100%; text-align: center">
          <el-button
            @click="submitResForm('resForm')"
            class="btn"
            type="primary"
            style="display: inline-block"
            >注册</el-button
          >
          <el-button
            @click="resetLoginForm"
            class="btn"
            type="primary"
            style="display: inline-block"
            >重置</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import store from "@/store";
export default {
  inject: ["reload"],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6 || value.length > 24) {
        callback(new Error("请输入6-24位密码"));
      } else {
        if (this.res_form.checkPass !== "") {
          this.$refs.resForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.res_form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var regEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请正确填写邮箱"));
      } else {
        if (value !== "") {
          var reg =
            /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
          if (!reg.test(value)) {
            callback(new Error("请输入有效的邮箱"));
          }
        }
        callback();
      }
    };

    return {
      // 注册表单
      res_form: {
        username: "",
        password: "",
        checkPass: "",
        email: "",
        code: "",
      },
      yzmtext: "获取验证码",
      btnBool: false,
      //   注册的表单规则
      res_rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        email: [{ validator: regEmail, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  created() {},
  methods: {
    // 账号注册
    submitResForm(formName) {
      window.sessionStorage.getItem("ipclients");
      window.sessionStorage.getItem("institutions");
      // this.$message({
      //   message: "注册成功，请重新登录！",
      //   type: "success",
      // });
      // store.clearCookie("token");
      // this.$router.push("/");
      // this.reload();
      //   console.log(formName);
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //  this.$router.push("/");
      if (
        this.res_form.username !== "" &&
        this.res_form.password !== "" &&
        this.res_form.code !== "" &&
        this.res_form.email !== ""
      ) {
        this.$http
          .post("/register", {
            name: this.res_form.username,
            password: this.res_form.password,
            email: this.res_form.email,
            code: this.res_form.code,
            // name: "aaa",
            // password: "123456",
            // email: "21099836595@qq.com",
            // code: "123456",
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code == "200") {
              this.$message({
                message: "注册成功，请重新登录！",
                type: "success",
              });
              this.$router.push("/");
              // this.reload();
            }
            if (res.data.code !== "200") {
              this.$refs["resForm"].resetFields();
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            console.log(err.response.data);
            this.$message.error({
              message: err.response.data.msg,
              //  type: 'warning'
            });
          });
      } else {
        this.$message({
          message: "请完善注册信息！！",
          type: "warning",
        });
      }
      //   } else {
      //     return false;
      //   }
      // });
    },
    // 重置功能
    resetLoginForm() {
      this.$refs["resForm"].resetFields();
    },

    // 获取验证码
    codes() {
      // console.log(this.res_form.email);
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (this.res_form.email !== "" && reg.test(this.res_form.email)) {
        this.$http
          .post("/send", {
            email: this.res_form.email,
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.btnBool = true;
              let i = 60; //倒计时时间
              let timer = setInterval(() => {
                this.yzmtext = +i + "   s   ";
                i--;
                if (i < 0) {
                  this.btnBool = false;
                  this.yzmtext = "获取邮箱验证码";
                  clearInterval(timer);
                }
              }, 1000);
              this.$message({
                message: "发送邮件成功，请查收！",
                type: "success",
              });
            }
          })
          .catch((error) => {
            this.$message.error("邮箱已绑定");
          });
      }
    },
  },
};
</script>
<style  lang='less' scoped>
.message {
  text-align: center;
}
</style>
<style lang='less' scoped>
.login_wrap {
  position: relative;
  width: 100%;
  height: 100vh;
  // background-image: url("../../assets/imgs/login.png");
  background-image: url("../../assets/imgs/背景图/9760eac49571416.jpg");

  background-size: 100% 100%;
  .login_box {
    position: absolute;

    left: 50%;
    top: 50%;
    display: flex;
    border-radius: 14px;
    width: 50%;
    max-width: 600px;
    height: 55%;
    min-width: 610px;

    padding: 30px 0;
    background: #eae9e8;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .login_top {
      padding-bottom: 20px;
      span {
        font-size: 36px;
      }
    }
    .login_bottom {
      width: 80%;
      .demo-ruleForm {
        .m_top_20 {
          /deep/.el-input {
            // width: 500px;
          }
        }
      }
    }
  }
}
</style>